export default __webpack_public_path__ + "f494034a94eb4a946076baf26e1a6441.png";